import React from "react";
import { Text, Group } from "@mantine/core";

export default function AccordionItem({ accordionState, label, description, index }) {
  const openTax = () => {
    window.open("https://docs.stripe.com/tax", "_blank");
  };

  return (
    <Group noWrap>
      <div>
        <Text size="lg" weight={700}>
          {label}
        </Text>

        {!accordionState[index] ? (
          <Text size="sm" color="dimmed" weight={400}>
            {description} {index == 2 && (
              <Text color="#41c3f6" underline component="a" onClick={openTax}>Stripe Tax</Text>
            )}
          </Text>
        ) : (
          ""
        )}
      </div>
    </Group>
  );
}
